import sceneBanner from "assets/img/demo/pic1@2x.png";
import aboutBanner from "assets/img/demo/pic2@2x.png";
import bgAudio from "assets/audio/temp2.mp3";
export default {
  noBrand: false,
  tempMode: "view",
  globalData: {
    bg: {
      src: bgAudio
    }
  },
  pages: [
    [
      {
        type: "text",
        content: "妮最美美妆店"
      },
      {
        type: "text",
        content: "活动时间：2020年3月10日-2020年5月1日"
      },
      {
        type: "text",
        content: "活动地址：合肥市望江西路666号讯飞大厦"
      },
      {
        type: "text",
        content: "开业期间多重好礼相送！"
      }
    ],
    [
      {
        photolist: [sceneBanner],
        type: "image",
        count: 1
      },
      {
        type: "text",
        content: "美妆活动介绍"
      },
      {
        type: "text",
        content: "开业期间到店消费每满399元减100\n开业当天部分商品买二送一\n开业当天到店均有礼包一份，送完即止"
      },
      {
        type: "text",
        content: "妮最美，你一直都最美"
      }
    ],
    [
      {
        photolist: [aboutBanner],
        type: "image",
        count: 1
      },
      {
        type: "text",
        content:
          "妮最美2010年创立于上海,是中国知名化妆品牌之一,在中国女性护肤品类市场占据相当大的市场份额。妮最美针对中国人的文化、饮食和肌肤特点研制,结合传统医学和现代科技,匠心打造天然温和的女性护肤品。"
      }
    ]
  ]
};
